exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-deployStage .handle {\n  cursor: move;\n}\n.table-deployStage .account-tag {\n  white-space: normal;\n}\n.table-deployStage td {\n  word-break: break-all;\n}\n", ""]);

